import React from "react";

const PremiumCourses = () => {
  return (
    <div>
      <h2>This is for Premium Course </h2>
    </div>
  );
};

export default PremiumCourses;
